import React from 'react'
import MerchantBadge from 'domains/merchant/atoms/merchant-badge'
import { MERCHANT_TYPE } from 'domains/merchant/constants'
import {
  STATUS,
  RETURN_TYPE
} from 'domains/merchant-outbound-return/constants'
import TimeUtil from 'utils/time-util'
import StatusBadge from 'domains/merchant-outbound-return/atoms/status-badge'
import ReturnTypeBadge from 'domains/merchant-outbound-return/atoms/return-type-badge'
import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'

/**
 * Merchant Inbound Reject Return Table Columns
 */
const merchantOutboundReturnTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick
}) => {

  // eslint-disable-next-line react/prop-types
  const MerchantTypeFilter = ({ column }) => {
    const options = Object.keys(MERCHANT_TYPE).map((key) => (
      {
        label : MERCHANT_TYPE[key],
        value : MERCHANT_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const StatusFilter = ({ column }) => {
    const options = Object.keys(STATUS).map((key) => (
      {
        label : STATUS[key],
        value : STATUS[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // eslint-disable-next-line react/prop-types
  const ReturnTypeFilter = ({ column }) => {
    const options = Object.keys(RETURN_TYPE).map((key) => (
      {
        label : RETURN_TYPE[key],
        value : RETURN_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter reactTableColumn={ column } options={ options } />
    )
  }

  // Custom Cell
  // Used to modify the cell in specific columns
  const MerchantTypeCell = (row) => <MerchantBadge merchant_type={ row.cell.value } />

  const StatusCell = (row) => <StatusBadge status={ row.cell.value } />

  const ReturnTypeCell = (row) => <ReturnTypeBadge returnType={ row.cell.value } />

  const DateCell = (row) => TimeUtil.format(row.cell.value)
  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      color={ buttonColour }
      onClick={ onButtonClick }
      text={ buttonText }
    />
  )

  return (
    [
      {
        Header   : 'Code',
        accessor : 'code'
      },
      {
        Header   : 'Type',
        accessor : 'return_type',
        Cell     : ReturnTypeCell,
        Filter   : ReturnTypeFilter
      },
      {
        Header  : 'Merchant',
        columns : [
          {
            Header   : 'Name',
            accessor : 'merchant.name',
            id       : 'merchant_name'
          },
          {
            Header   : 'Code',
            accessor : 'merchant.code',
            id       : 'merchant_code'
          },
          {
            Header   : 'Email',
            accessor : 'merchant.email',
            id       : 'merchant_email'
          },
          {
            Header   : 'Type',
            accessor : 'merchant.merchant_type',
            id       : 'merchant_type',
            Cell     : MerchantTypeCell,
            Filter   : MerchantTypeFilter
          }
        ]
      },
      {
        Header         : 'Qty',
        accessor       : 'total_quantity',
        disableFilters : true
      },
      {
        Header         : 'Created At',
        accessor       : 'created_at',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header         : 'Scheduled At',
        accessor       : 'scheduled_at',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header   : 'Status',
        accessor : 'status',
        Cell     : StatusCell,
        Filter   : StatusFilter
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )
}

export default merchantOutboundReturnTableColumns
